import type { paths } from '@orlikfy/api-interfaces';

export type { UserTrophyDto } from '@orlikfy/api-interfaces';

// GET /users/me
export const GET_MY_USER_PATH = '/users/me' as const satisfies keyof paths;
type GetMyUserOperation = paths[typeof GET_MY_USER_PATH]['get'];
export type GetMyUserResponse = GetMyUserOperation['responses'][200]['content']['application/json'];

// GET /user-profile/{userId}
export const GET_USER_PROFILE_PATH = '/user-profile/{userId}' as const satisfies keyof paths;
type GetUserProfileOperation = paths[typeof GET_USER_PROFILE_PATH]['get'];
export type GetUserProfilePathParams = GetUserProfileOperation['parameters']['path'];
export type GetUserProfileResponse = GetUserProfileOperation['responses'][200]['content']['application/json'];

// PATCH /users/me
export const UPDATE_MY_USER_PATH = '/users/me' as const satisfies keyof paths;
type UpdateMyUserOperation = paths[typeof UPDATE_MY_USER_PATH]['patch'];
export type UpdateMyUserBody = UpdateMyUserOperation['requestBody']['content']['application/json'];
export type UpdateMyUserResponse = UpdateMyUserOperation['responses'][200]['content']['application/json'];

// PATCH /users/me/language
export const SET_MY_LANGUAGE_PATH = '/users/me/language' as const satisfies keyof paths;
type SetMyLanguageOperation = paths[typeof SET_MY_LANGUAGE_PATH]['patch'];
export type SetMyLanguageBody = SetMyLanguageOperation['requestBody']['content']['application/json'];
export type SetMyLanguageResponse = SetMyLanguageOperation['responses'][200]['content']['application/json'];

// GET /trophies/user/{userId}
export const GET_TROPHIES_PER_USER_PATH = '/trophies/user/{userId}' as const satisfies keyof paths;
type GetTrophiesPerUserOperation = paths[typeof GET_TROPHIES_PER_USER_PATH]['get'];
export type GetTrophiesPerUserPathParams = GetTrophiesPerUserOperation['parameters']['path'];
export type GetTrophiesPerUserResponse =
  GetTrophiesPerUserOperation['responses']['default']['content']['application/json'];

// PUT /users/location
export const UPDATE_USER_LOCATION_PATH = '/users/location' as const satisfies keyof paths;
type UpdateUserLocationOperation = paths[typeof UPDATE_USER_LOCATION_PATH]['put'];
export type UpdateUserLocationBody = UpdateUserLocationOperation['requestBody']['content']['application/json'];
export type UpdateUserLocationResponse = UpdateUserLocationOperation['responses'][200]['content']['application/json'];
